import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSparkle"><Path d="M2 13C5.35015 13 7.5341 13.74 8.89706 15.1029C10.26 16.4659 11 18.6498 11 22H13C13 18.6498 13.74 16.4659 15.1029 15.1029C16.4659 13.74 18.6498 13 22 13V11C18.6498 11 16.4659 10.26 15.1029 8.89706C13.74 7.5341 13 5.35015 13 2H11C11 5.35015 10.26 7.5341 8.89706 8.89706C7.5341 10.26 5.35015 11 2 11V13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSparkle;
